module.exports = __webpack_public_path__ + "img/article-3-2.068f8455.jpg";